import * as actionTypes from "../../Action/actionTypes";

const initialState = {
  workspace: null,
  reservationData: null,
  reservationDate: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_WORKSPACE:
      return {
        ...state,
        workspace: action.value
      };
    case actionTypes.REMOVE_WORKSPACE:
      return {
        ...state,
        workspace: null
      };
    case actionTypes.SAVE_RESERVATION_DATA:
      return {
        ...state,
        reservationData: action.value
      };
    case actionTypes.REMOVE_RESERVATION_DATA:
      return {
        ...state,
        reservationData: null
      };
    case actionTypes.STORE_RESERVATION_DATE:
      return {
        ...state,
        reservationDate: action.value
      };
    default:
      return state;
  }
};

export default reducer;
